export default __webpack_public_path__ + "static/media/spei.a90546d7.png";